import { render, staticRenderFns } from "./SelectTipoInstrumento.vue?vue&type=template&id=a5c72440"
import script from "./SelectTipoInstrumento.vue?vue&type=script&lang=js"
export * from "./SelectTipoInstrumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports